export default __webpack_public_path__ + "static/media/samoon-bread.1da5947c.jpg";